import React from 'react';

function Terms() {
  return (
    <div>
      <div className="bg-secondary py-9">
        <div className="text-center font-light text-xl sm:text-2xl xl:text-4xl">
          Terms And <b>Conditions</b>
        </div>
      </div>
      <div className="px-5 my-2 lg:px-14 lg:my-10">
        <div className="my-5 font-light leading-9 text-gray text-base sm:text-lg lg:text-xl 2xl:text-2xl">
          1. 24 7 Radio Carz is a legal entity of Select Private Hire Limited,
          company number 02304045, registered address 1214A Warwick Road, B27
          6BY.
          <br />
          2. All journeys with 24-7 Cars must be pre-booked using one of the
          booking methods described on the Website.
          <br />
          3. All journeys to the Railway, Bus or Coach station must be booked
          for pick up at least 1 hour before departure in order to guarantee the
          connection.
          <br />
          4. Lost property left in an 24-7 Cars vehicle will be returned to the
          office.
          <br />
          5. Please contact the main office to collect your lost property.
          <br />
          6. Lost Property not collected within 3 months of the journey becomes
          the property of 24-7 Cars who will arrange for disposal of the item.{' '}
          <br />
          7. If you have any comments or complaints about the service we have
          provided, please contact the office, by phone, text or by the form on
          the website. <br />
          8. All telephone calls are recorded for monitoring purposes
          <br />
          9. These terms and conditions do not remove or affect your statutory
          rights.
          <br />
        </div>
      </div>
    </div>
  );
}

export default Terms;
